import * as yup from 'yup'
export const NO_SPECIAL_CHAR = /^[^!@#$%^&*()+=\\[\]{};:'",.<>?/`~]*$/

export const addPickerMapSchema = yup.object({
  pickerName: yup
    .string()
    .required('Picker name is required field')
    .min(2, 'Picker name must be between 2 and 150 characters.')
    .max(150, 'Picker name must be between 2 and 150 characters.')
    .trim(),
  pickerId: yup
    .string()
    .required('Picker ID is required field')
    .max(100, 'Picker ID must be at most 100 characters.')
    .trim(),
})

export const updatePickerMap = addPickerMapSchema.shape({
  // Shown from the picker, never edited here
  empId: yup.string().nullable().optional(),
  firstName: yup.string().optional(),
  lastName: yup.string().optional(),
})

export const updatePickerMapSchema = yup.object({
  mappings: yup.array().of(updatePickerMap).required('Mappings are required'),
})
